import CloseIcon from '@mui/icons-material/Close';
import { Grid, IconButton, Typography, useTheme } from '@mui/material';
import { headerWrapperStyles, svgItemWrapperStyles } from './Chatbot.styles';
import TAGSvgIcon from '../TAGSvgIcon/TAGSvgIcon';
import ImageWrapper from '@shared-components/components/ImageWrapper';
import { TAGBrand } from '@shared-components/types';
interface IChatbotHeader {
  handleClose: () => void;
  logoUrl?: string;
}
const ChatbotHeader = ({
  handleClose,
  logoUrl = ''
}: IChatbotHeader) => {
  const theme = useTheme();
  const {
    brand
  } = theme;
  const getLogoAltText = (brand: TAGBrand) => {
    if (brand === TAGBrand.Lovet) {
      return 'Lovet Logo';
    }
    return 'Logo';
  };
  const logoAltText = getLogoAltText(brand as TAGBrand);
  return <Grid container justifyContent="space-between" alignItems="center" direction="row" spacing={1} data-testid="chatbot_header" sx={headerWrapperStyles} data-sentry-element="Grid" data-sentry-component="ChatbotHeader" data-sentry-source-file="ChatbotHeader.tsx">
			<Grid item sx={svgItemWrapperStyles(theme, brand as TAGBrand)} data-sentry-element="Grid" data-sentry-source-file="ChatbotHeader.tsx">
				<TAGSvgIcon icon="AspenChatLogoWhite" dataTestId="chatbot_header_logo" data-sentry-element="TAGSvgIcon" data-sentry-source-file="ChatbotHeader.tsx" />
			</Grid>
			<Grid item data-sentry-element="Grid" data-sentry-source-file="ChatbotHeader.tsx">
				{logoUrl ? <ImageWrapper src={logoUrl} alt={logoAltText} style={{
        width: '132px',
        height: 'auto'
      }} /> : <Typography variant="header4" data-testid="chatbot_header_title">
						Amelia Virtual Assistant
					</Typography>}
			</Grid>
			<Grid item data-sentry-element="Grid" data-sentry-source-file="ChatbotHeader.tsx">
				<IconButton onClick={handleClose} aria-label="Close chatbot" data-sentry-element="IconButton" data-sentry-source-file="ChatbotHeader.tsx">
					<CloseIcon data-testid="chatbot_header_Close_icon" data-sentry-element="CloseIcon" data-sentry-source-file="ChatbotHeader.tsx" />
				</IconButton>
			</Grid>
		</Grid>;
};
export default ChatbotHeader;